/** Shared ceiling for authored bin, guide and gradient counts. */
export const VEGA_LITE_MAX_RESOURCE_COUNT = 200;

/** UTF-16 code units, including intermediates; bounded split also charges its array entries. */
export const VEGA_LITE_CALCULATE_LIMITS = {
  maxInputStringLength: 1024,
  maxStringLength: 4096,
  maxAllocatedStringLength: 8192,
} as const;
